"use client";

import Link from "next/link";
import { useLang } from "@/lib/LanguageContext";
import type { Locale } from "@/lib/i18n";
import { ButtonPrimary } from "@/components/ui/ButtonPrimary";
import { ButtonOutline } from "@/components/ui/ButtonOutline";

const copy: Record<Locale, { title: string; body: string; home: string; contact: string }> = {
  bg: {
    title: "Тази страница не съществува",
    body: "Възможно е адресът да е сгрешен или страницата да е преместена.",
    home: "Към началната страница",
    contact: "Свържете се с нас",
  },
  en: {
    title: "This page doesn't exist",
    body: "The address may be mistyped or the page may have moved.",
    home: "Back to homepage",
    contact: "Contact us",
  },
};

export default function NotFoundPage() {
  const { locale } = useLang();
  const c = copy[locale];

  return (
    <div className="relative bg-[#07070C] min-h-screen flex items-center pt-24 md:pt-32 pb-16">
      <div className="container max-w-2xl px-4 sm:px-6 text-center">
        <p className="font-display font-extrabold text-gradient-warm text-[clamp(72px,14vw,140px)] leading-none">
          404
        </p>
        <h1 className="mt-6 font-display font-bold text-white text-[clamp(26px,4vw,40px)] leading-tight">
          {c.title}
        </h1>
        <p className="mt-4 text-white/55 text-base sm:text-lg">{c.body}</p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <Link href="/">
            <ButtonPrimary size="lg">{c.home}</ButtonPrimary>
          </Link>
          <Link href="/contact">
            <ButtonOutline size="lg">{c.contact}</ButtonOutline>
          </Link>
        </div>
      </div>
    </div>
  );
}
